import { Expose, Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class LocationStockItemDto {
  @Expose()
  consumableId: string;

  @Expose()
  consumableName: string;

  @Expose()
  consumableReference: string;

  @Expose()
  categoryName: string;

  @Expose()
  subcategoryName: string;

  @Expose()
  metricName: string;

  @Expose()
  stock: number;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  averagePrice: number;

  get totalPrice(): number {
    return this.stock * this.averagePrice;
  }
}
